import {useHistory} from "react-router";
import Layout from "@/layout/Layout";
import MButton from "@/components/atom/MButton";
import React, {useEffect, useState} from "react";
import {getMySubscription} from "@/api/subscription";
import _ from 'lodash'
import {yyyymmdd} from "@/util/date";
import globalStyle from "@/styles/Global.scss";

export const Subscription = () => {
  const history = useHistory()
  const [subscriptions, setSubscriptions] = useState([])

  useEffect(() => {
    (async () => {
      const subscriptions = await getMySubscription()
      setSubscriptions(subscriptions)
    })()
  }, [])

  const toPurchase = () => {
    history.push(`/purchase`)
  }

  const goBack = () => {
    history.goBack()
  }

  return (
    <>
      <Layout category={'WA'} title={'購入履歴'}>
        <MButton onClick={toPurchase} value={'購入'}/>
        <div className={globalStyle.container}>
          <h3>購入履歴</h3>
          {
            _.map(subscriptions, (s) => {
              return (
                <React.Fragment key={s.id}>
                  <div className={globalStyle.groupContainer}>
                    <div className={globalStyle.attribute}>
                      <div className={globalStyle.title}>購入日</div>
                      <div className={globalStyle.staticValue}>
                        <span>{s.purchase && yyyymmdd(s.purchase.purchaseDate)}</span>
                      </div>
                    </div>
                    <div className={globalStyle.attribute}>
                      <div className={globalStyle.title}>有効期限</div>
                      <div className={globalStyle.staticValue}>
                        {yyyymmdd(s.availableAt)}〜{yyyymmdd(s.expireAt)}
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              )
            })
          }
          <MButton image={'back.png'} onClick={goBack} value={'戻る'}/>
        </div>
      </Layout>
    </>
  )
}
